import { Component, Input, OnInit } from '@angular/core';
import { DefaultValueConstants } from '../../constants/default-value-constants';
import { SpeedDialMenu } from '../../models/speed-dial-menu';

@Component({
  selector: 'app-speed-dial',
  templateUrl: './speed-dial.component.html',
  styleUrls: ['./speed-dial.component.scss']
})
export class SpeedDialComponent implements OnInit {
  @Input() menuItemsData!: SpeedDialMenu[]
  items!:SpeedDialMenu[]
  dialType:string = DefaultValueConstants.Quarter_Circle_DialType;
  dialDirection:string = DefaultValueConstants.Left_Down_DialDirection;
  displaySpeedDial=false;
  constructor() { }

  ngOnInit(): void {
    this.items = this.menuItemsData;
    this.displaySpeedDial=this.items.length>0?true:false;
    if (this.items.length == 1) {
      this.dialType = DefaultValueConstants.Linear_DialType;
      this.dialDirection = DefaultValueConstants.Left_DialDirection;
    }
    else if (this.items.length > 1) {
      this.dialType = DefaultValueConstants.Quarter_Circle_DialType;
      this.dialDirection = DefaultValueConstants.Left_Down_DialDirection;
    }
  }

}
